import React, { Component } from 'react'
import './App.css'
import Top from './Top.js'
import Project from './Project.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faLink, faGamepad } from '@fortawesome/free-solid-svg-icons'
import { Spring } from 'react-spring'

const JSON_URL = 'https://gist.githubusercontent.com/FR0ST1N/c5986e51112681adc998ca63b3c239ba/raw/projects.json'
library.add(fab, faEnvelope, faLink, faGamepad)

class App extends Component {
  constructor (props) {
    super(props)
    this.state = { data: null }
    this.renderEverything = this.renderEverything.bind(this)
  }

  componentDidMount () {
    fetch(JSON_URL)
      .then(response => response.json())
      .then(data => this.setState({ data: data.projects }))
  }

  renderEverything = () => {
    const projectElements = []
    projectElements.push(<h3 key='projects'>Projects</h3>)
    for (let i = 0; i < this.state.data.length; i++) {
      projectElements.push(
        <Project key={this.state.data[i].name} name={this.state.data[i].name} description={this.state.data[i].description} links={this.state.data[i].links} />
      )
    }
    projectElements.push(<a key='more' className='a-style' rel='noopener noreferrer' target='_blank' href='https://github.com/FR0ST1N'>More On GitHub</a>)

    return (
      <div>
        <Top />
        <Spring
          from={{ opacity: 0 }}
          to={{ opacity: 1 }}
          config={{ duration: 1000 }}
        >
          {props => <div style={props}>{projectElements}</div>}
        </Spring>
      </div>
    )
  };

  render () {
    return (
      <div className='App'>
        {
          this.state.data != null ? this.renderEverything() : null
        }
      </div>
    )
  }
}

export default App
